const translations = {
    'scout.title': 'Wyślij zwiad',
    'scout.missingSettlement': 'Brak osady do wysłania zwiadu.',
    'scout.destination': 'Cel',
    'scout.tile': 'Pole: %s',
    'scout.distance': 'Dystans: %d',
    'scout.units': 'Oddziały',
    'scout.unitsNone': 'Brak dostępnych typów jednostek.',
    'scout.unitLine': '%s: %d/%d',
    'scout.unitPlus': '+1',
    'scout.unitMinus': '-1',
    'scout.food': 'Zaopatrzenie',
    'scout.foodAvailable': 'Dostępne jedzenie: %d',
    'scout.foodSelected': 'Wybrane jedzenie: %d',
    'scout.foodSuggested': 'Sugerowane: %d',
    'scout.foodPlus': '+ jedzenie',
    'scout.foodMinus': '- jedzenie',
    'scout.launch': 'Wyprawa',
    'scout.send': 'Wyślij zwiad',
    'scout.missionTitle': 'Misja zwiadowcza',
    'scout.missionMissing': 'Nie znaleziono misji zwiadowczej.',
    'scout.missionStatus': 'Status',
    'scout.missionTarget': 'Cel: %s',
    'scout.missionState.traveling': 'W drodze',
    'scout.missionState.battle': 'Bitwa',
    'scout.missionState.holding': 'Utrzymuje pozycję',
    'scout.missionState.returning': 'Powrót',
    'scout.missionState.complete': 'Zakończona',
    'scout.missionProgress': 'Postęp: %d/%d',
    'scout.missionBattleProgress': 'Bitwa: %d/%d',
    'scout.missionPlan': 'Plan',
    'scout.missionPlanEmpty': 'Brak zaplanowanego celu.',
    'scout.missionPlanNext': 'Następny cel: %s',
    'scout.missionPlanAlter': 'Zmień następny cel',
    'scout.missionPlanClear': 'Wyczyść plan',
    'scout.missionPlanHint': 'Wybierz pole, aby ustawić następny cel.',
    'scout.missionOrders': 'Rozkazy',
    'scout.missionReturn': 'Powrót do osady',
    'scout.missionReport': 'Raport z bitwy',
    'scout.missionReportOpen': 'Otwórz raport',
};

export default translations;
